import { render, staticRenderFns } from "./WhitelabelMainHeader.vue?vue&type=template&id=b9cc7a4c&scoped=true&"
import script from "./WhitelabelMainHeader.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelMainHeader.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelMainHeader.vue?vue&type=style&index=0&id=b9cc7a4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cc7a4c",
  null
  
)

export default component.exports